<template>

  <!-- User orders -->
  <profile-order-list :in18="in18" :user="user"/>

  <!-- User details -->
  <profile-details :banks="banks" :captcha_site_key="captcha_site_key" :in18="in18" :user="user"/>

</template>

<script>

import ProfileOrderList from '../components/profile/ProfileOrderList.vue'
import ProfileDetails from '../components/profile/ProfileDetails.vue'
import ProfileAddress from '../components/profile/ProfileAddress.vue'

export default {
  components: {
    ProfileOrderList,
    ProfileDetails,
    ProfileAddress,
  },
  props:      {
    in18:             {
      type: Object
    },
    captcha_site_key: {
      type: String
    }
  },
  data() {
    return {
      user:  {},
      banks: [],
    };
  },
  created() {
    axios.get('/api/user').then((response) => {
      this.user = response.data.user;
    });
    axios.get('/api/banks').then((response) => {
      this.banks = response.data.banks;
    });
  },
};
</script>